// 系统配置
import { get_ver_info } from '@/api/cmsWebSite'
// import { getConfig } from '@/api/config'

export default {
  state: {
    verConfig: {},
  },

  mutations: {
    SET_VER_CONFIG(state, verConfig) {
      state.verConfig = { ...verConfig }
    },
  },

  actions: {
    async GetVerConfig({ commit }) {

      let localConfig = await get_ver_info('/upgrade.json').then(({data}) => {
        return data
      })
      // let config = await getConfig().then(({data}) => {
      //   return data.config
      // })

      // localConfig['try'].unit_price = parseFloat(config.vip1_price)
      // localConfig['advanced'].unit_price = parseFloat(config.vip2_price)
      // localConfig['specialty'].unit_price = parseFloat(config.vip3_price)
      // localConfig['exclusive'].unit_price = parseFloat(config.vip4_price)

      // for(let key in localConfig) {
      //   let ver = localConfig[key]
      //   ver.duration.forEach(item => {
      //     // 原价 = 单价 * 时长
      //     item.origin_price = ver.unit_price * item.vip_time_length
      //     // 实际价格(折扣价) = 原价 * 折扣 /100
      //     item.price = (item.origin_price * item.rebate / 100).toFixed(2);
      //     // 可节省价格 = 原价 - 实际价格(折扣价)
      //     item.spare_price = (item.origin_price - item.price).toFixed(2)
      //   })
      // }
      commit('SET_VER_CONFIG', localConfig)
      return localConfig
    },
  },
}